module.exports = __webpack_public_path__ + "img/logo1 (5).837b282a.jpg";